import { Card, Row, Col } from 'antd';
import React from 'react';
import Auxiliary from '../../../util/Auxiliary';
import { useManpower } from './data';
import Item from './Item';
import Chart from './Charts/Manpower';

const ManpowerStatistic = () => {
  const { loading, manpower } = useManpower();
  return (
    <Auxiliary>
      <Card className="gx-card gx-p-15 gx-text-center" title="Manpower">
        {loading ? "Sedang memuat..." : (
          <Row>
            {manpower.map((item, key) => {
              return (
                <Col span={12} key={`manpower-stats-${key}`}>
                  <Item label={item.name} value={item.value}/>
                </Col>
              );
            })}
          </Row>
        )}
        <hr />
        <Chart loading={loading} manpower={manpower} />
      </Card>
    </Auxiliary>
  );
}

export default ManpowerStatistic;